import { isRecord } from "@atlassiansox/bxp-shared-utils";
export function isUnpublishedEntry(model) {
    if (!isRecord(model)) {
        return false;
    }
    return (isRecord(model.sys) &&
        model.sys.type === "Link" &&
        model.sys.linkType === "Entry" &&
        typeof model.sys.id === "string");
}
export function isUnpublishedAsset(model) {
    if (!isRecord(model)) {
        return false;
    }
    return (isRecord(model.sys) &&
        model.sys.type === "Link" &&
        model.sys.linkType === "Asset" &&
        typeof model.sys.id === "string");
}
//# sourceMappingURL=view-model-error.types.js.map